import { useEffect, useRef, useState } from 'react';

import MenuBtn from '@components/MenuBtn';
import MenuBtnStickyMobile from '@components/MenuBtn/MenuBtnStickyMobile';
import MenuActions from '../Actions';
import style from '../index.module.scss';
import OffCanvasMenu from '../OffCanvasMenu';
import StickyOffCanvasMenu from '../OffCanvasMenu/stickyMenu';

import { MENU_OFFCANVAS } from '@lib/constants';

export default function StickyMenu({ isSecondaryStyle = false, isAdvisorView = false }) {
	const [menuState, setMenuState] = useState(false);
	const menuRef = useRef(null);

	const setMenuToggleState = (currentState) => {
		setMenuState(currentState);
	};

	useEffect(() => {
		const masthead = document.querySelector('.masthead');

		function handleClickOutside(event) {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				setMenuState(false);
			}
		}

		if (menuState) {
			document.body.classList.add('no-overflow');
			masthead?.classList.add('menuOpen');

			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.body.classList.remove('no-overflow');
			masthead?.classList.remove('menuOpen');

			document.removeEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.body.classList.remove('no-overflow');
			masthead?.classList.remove('menuOpen');
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [menuState]);

	return (
		<>
			<div
				ref={menuRef}
				className={`${style.sticky} ${style.menuRight} ${menuState && style.isOpen} menuSticky menuRight masthead__right`}
			>
				<div className="desktop-only desktopMenu">
					<MenuActions toggleMenuState={setMenuToggleState} isAdvisorView={isAdvisorView} />
					{MENU_OFFCANVAS && (
						<>
							<MenuBtn currentMenuState={menuState} menuState={(e) => setMenuToggleState(e)} />
							<div
								className={`${style.additionalContainer} ${style.desktopOffCanvas} offCanvasMenuContainer`}
							>
								<OffCanvasMenu />
							</div>
						</>
					)}
				</div>

				<div className={`mobileMenu ${style.mobileWrap}`}>
					<div className={style.mobileBackground}>
						<MenuActions toggleMenuState={setMenuToggleState} isAdvisorView={isAdvisorView} />

						{MENU_OFFCANVAS && (
							<MenuBtnStickyMobile
								currentMenuState={menuState}
								menuState={(e) => setMenuToggleState(e)}
							/>
						)}
					</div>

					{MENU_OFFCANVAS && (
						<div className={`${style.additionalContainer} additional-container ${style.sticky}`}>
							<StickyOffCanvasMenu />
						</div>
					)}
				</div>
			</div>
		</>
	);
}
